import styled, { css } from "styled-components";

export const InputSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(250px, 386px));
  gap: ${({ gap }) => gap || `30px 5%`};
  justify-content: start;
  align-items: start;

  ${({ responsiveBreakpoint, responsiveColumns, disableResponsive }) =>
    !disableResponsive &&
    responsiveBreakpoint &&
    css`
      @media screen and (max-width: ${responsiveBreakpoint}) {
        grid-template-columns: ${responsiveColumns || "1fr"};
      }
    `}
`;

export const AssigneeSection = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: auto;
  gap: 10px;
`;
export const TimeRangeSection = styled.div`
  display: grid;
  grid-template-columns: 45% 45%;
  gap: 5%;
  justify-content: space-between;
  align-items: start;
`;
export const AddTaskLocationSection = styled.div`
  display: grid;
  grid-template-columns: 350px 1fr;
`;
export const AddTaskLocationInfoContainer = styled.div`
  /* display: grid;
    gap: 30px; */
  padding: 20px;
`;

export const SubTaskTableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) =>
    columns || "20px 1fr 1fr 1fr 100px"};
  grid-column-gap: 20px;
  justify-content: flex-start;
  padding: ${({ padding,theme }) => padding || theme.table.tableHeaderPadding};
  // border-bottom: 1px solid ${({ isLastItem, theme }) => isLastItem ? "none" : theme.colors.border.secondary};
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.tableHeaderBackground};
`;

export const SubTaskTableRowContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) =>
    columns || "20px 1fr 1fr 1fr 100px"};
  grid-column-gap: 20px;
  justify-content: flex-start;
  padding: ${({ padding,theme }) => padding || theme.table.tableRowPadding};
  border-bottom: ${({ isLastItem, theme }) =>
    isLastItem ? "none" : `1px solid ${theme.colors.border.tableBorder}`};
  background-color: ${({ theme }) => theme.colors.main.white};
  // :nth-of-type(even) {
  //   background-color: #f8f9fc;
  // }
`;



export const LineItemTableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) =>
    columns || "10px minmax(50px, 2fr) minmax(30px,70px) minmax(50px, 2fr) 70px 100px 100px 70px minmax(80px, 1fr)"};
  grid-column-gap: 20px;
  justify-content: flex-start;
  padding: ${({ padding,theme }) => padding || theme.table.tableHeaderPadding};
  // border-bottom: 1px solid ${({ isLastItem, theme }) => isLastItem ? "none" : theme.colors.border.secondary};
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.tableHeaderBackground};
  z-index: -1;
`;

export const LineItemTableRowContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) =>
    columns || "10px minmax(50px, 2fr) minmax(30px,70px) minmax(50px, 2fr) 70px 100px 100px 70px minmax(80px, 1fr)"};
  grid-column-gap: 20px;
  justify-content: flex-start;
  padding: ${({ padding,theme }) => padding || theme.table.tableRowPadding};
  border-bottom: ${({ isLastItem, theme }) =>
    isLastItem ? "none" : `1px solid ${theme.colors.border.tableBorder}`};
  background-color: ${({ theme }) => theme.colors.main.white};
  // :nth-of-type(even) {
  //   background-color: #f8f9fc;
  // }
  z-index: 1;
`;